import Vue from 'vue';
import Router from 'vue-router';
import Index from './components/Index/Index';
import Store from '@/Store/Store';
import UserModel from '@/models/UserModel';
Vue.use(Router);

function guardMyroute(to: any, from: any, next: any) {
  if (to.fullPath === '/GroupedWekalaRequest') {
    const usr: UserModel = Store.getters['getCurrentUserGetter'];
    if (usr.isImpersonated) {
      return false;
    }
    // if (usr.isPrisoner) {
    //   return false;
    // }
    next();
  }
}





export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Index,
    },
    {
      path: '/procuration-verification',
      name: 'ProcurationVerification',
      component: () =>
        import('./components/ProcurationVerification/ProcurationVerification'),
      props: (route) => ({
        procurationNumber: route.query.procurationNumber,
        socialId: route.query.socialId,
        q: route.query.q,
      }),
      meta: {
        breadcrumb: [
          { name: 'dashboard', url: '/applications/landing' },
          { name: 'admissionDetails.pageTitle', url: '/VerificationServices' },

          { name: 'procurationVerification' },
        ],
      },
    },
    {
      path: '/grouped-request/:code',
      name: 'GroupedRequestDetailRoute',
      component: () =>
        import(
          './components/GroupedRequestDetail/GroupedRequestDetailComponent'
        ),
      props: (route) => ({ code: route.params.code }),
      meta: {
        breadcrumb: [
          { name: 'procurations.title', link: '/procurations-query' },
          { name: 'attorneyRegistration.GroupedRequestDetails.title' },
        ],
      },
    },
    {
      path: '/procurations/:procurationNumber',
      name: 'ProcurationWrapper',
      component: () =>
        import('./components/ProcurationWrapper/ProcurationWrapper'),
      props: (route) => ({ procurationNumber: route.params.procurationNumber }),
      meta: {
        breadcrumb: [
          { name: 'procurations.title', link: '/procurations-query' },
          { name: 'attorneyRegistration.attorneyDetails.title' },
        ],
      },
    },
    {
      path: '/subwekalaDetail/:procurationNumber',
      name: 'subwekalaDetail',
      component: () => import('./components/SubWekalaWrapper/SubWekalaWrapper'),
      props: (route) => ({ procurationNumber: route.params.procurationNumber }),
      meta: {
        breadcrumb: [
          { name: 'procurations.title', link: '/procurations-query' },
          {
            name: 'attorneyRegistration.attorneyDetails.title',
            link: '/procurations',
          },
          { name: 'procurationsVerification.subwekala' },
          { name: 'procurationsVerification.subwekalaDetail' },
        ],
      },
      beforeEnter: (to: any, from, next) => {
        if (from.params.wekalaNumber) {
          to.meta.breadcrumb[1].link = `/procurations/${from.params.wekalaNumber}`;
        } else {
          to.meta.breadcrumb[1].link = '';
        }
        if (from.fullPath === '/') {
          to.meta.breadcrumb[2].link = ''
        } else {
          to.meta.breadcrumb[2].link = from.fullPath;
        }
        next();
      },
    },
    {
      path: '/subwekala/:wekalaNumber/:wekalaId/:nationalId',
      name: 'subwekala',
      component: () =>
        import('@/shared/components/SubWekalaListComponent/SubWekalaList'),
      props: (route) => ({
        wekalaNumber: route.params.wekalaNumber,
        wekalaId: route.params.wekalaId,
        nationalId: route.params.nationalId,
      }),
      meta: {
        breadcrumb: [
          { name: 'procurations.title', link: '/procurations-query' },
          {
            name: 'attorneyRegistration.attorneyDetails.title',
            link: '/procurations',
          },
          { name: 'procurationsVerification.subwekala' },
        ],
      },
      beforeEnter: (to: any, from, next) => {
        to.meta.breadcrumb[1].link = `/procurations/${to.params.wekalaNumber}`;
        next();
      },
    },
    {
      path: '/register',
      name: 'AttorneyRegistrationRequest',
      component: () =>
        import(
          './components/AttorneyRegistration/Component/RequestTypeSelection/RequestTypeSelection'
        ),
      meta: {
        breadcrumb: [
          { name: 'dashboard', url: '/applications/landing' },

          { name: 'attorneyRegistration.title' },
        ],
      },
    },
    {
      path: '/GroupedWekalaRequest',
      name: 'GroupedWekalaRequest',
      beforeEnter: guardMyroute,
      component: () =>
        import(
          './components/AttorneyRegistration/GroupedWekalaRequest/GroupedWekalaRequest'
        ),
    },
    {
      path: '/CopyWekala',
      name: 'CopyWekala',
      component: () =>
        import(
          './components/AttorneyRegistration/CopyWekalaComponent/CopyWekalaComponent'
        ),
    },
    {
      path: '/register-single',
      name: 'SingleAttorneyRegistrationRequest',
      component: () =>
        import(
          './components/AttorneyRegistration/AttorneyRegistrationRequest/AttorneyRegistrationRequest'
        ),
    },
    {
      path: '/preview',
      name: 'preview',
      component: () =>
        import('./components/AttorneyRegistration/Preview/Preview'),
    },
    {
      path: '/procurations-query',
      name: 'ProcurationQuery',
      component: () =>
        import('./components/ProcurationQueryTabs/ProcurationQueryTabs'),
      props: (route) => ({
        isRequestUrl: route.query.isRequestUrl,
        isTasdekRequestUrl: route.query.isTasdekRequestUrl,
        isDraftUrl: route.query.isDraftUrl,
      }),
      beforeEnter: (to: any, from, next) => {

        if (from.name && from.name.toLowerCase().indexOf('grouped') >= 0) {
          to.query.isRequestUrl = true;
        }

        if (to && to.query && to.query.isDraftUrl == 'true') {
          to.query.isDraftUrl = true;
        }

        if (from.name && from.name.toLowerCase().indexOf('tasdek') >= 0) {
          to.query.isTasdekRequestUrl = true;
        }
        next();
      },
    },
    {
      path: '/EditExTasdekRequest/:code',
      name: 'EditExTasdekRequest',
      component: () =>
        import(
          './components/ExternalTasdek/EditExternalTasdekRequest/EditExternalTasdekRequest'
        ),
      props: (route) => ({ code: route.params.code }),
    },
    {
      path: '/ExTasdekRequest',
      name: 'ExTasdekRequest',
      component: () =>
        import(
          './components/ExternalTasdek/ExternalTasdekRequest/ExternalTasdekRequest'
        ),
    },
    {
      path: '/ViewTasdekRequest/:code',
      name: 'ViewTasdekRequestRoute',
      component: () =>
        import(
          './components/ExternalTasdek/ExternalTasdekView/ExternalTasdekView'
        ),
      props: (route) => ({ code: route.params.code }),
      meta: {
        breadcrumb: [
          { name: 'procurations.title', link: '/procurations-query' },
          { name: 'attorneyRegistration.GroupedRequestDetails.title' },
        ],
      },
    },
    {
      path: '/favoriteList',
      name: 'favoriteList',
      component: () =>
        import('./components/FavoritePersonList/FavoritePersonList'),
      meta: {
        breadcrumb: [
          { name: 'procurations.title', link: '/procurations-query' },
          { name: 'favoritePerson.pageTitle' },
        ],
      },
    },
    {
      path: '/addFavorite',
      name: 'addFavorite',
      component: () =>
        import('./components/AddFavoritePerson/AddFavoritePerson'),
      meta: {
        breadcrumb: [
          // { name: 'procurations.title', link: '/procurations-query' },
          // { name: 'favoritePerson.pageTitle' },
        ],
      },
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('./components/testcomp/test'),
    },
  ],


});


